// components/home/Hero/index.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "../../../styles/components";
import { selectUserSubscription } from "../../../store/slices/subscriptionSlice";
import { useAuth } from "../../../hooks/useAuth";
import {
	HeroWrapper,
	HeroContainer,
	HeroContent,
	HeroTitle,
	HeroDescription,
	ButtonGroup,
	ImageWrapper,
} from "./styles";

const Hero = () => {
	const navigate = useNavigate();
	const { user } = useAuth();
	const subscription = useSelector(selectUserSubscription);
	const hasActiveSubscription = subscription?.status === "active";

	return (
		<HeroWrapper>
			<HeroContainer>
				<HeroContent
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
				>
					<HeroTitle>
						Capture Your Baby's <span>Precious Moments</span>
					</HeroTitle>
					<HeroDescription>
						Professional photography subscription service dedicated to
						documenting your baby's growth journey with monthly sessions and
						premium quality photos.
					</HeroDescription>
					<ButtonGroup>
						{user && hasActiveSubscription ? (
							<Button size="large" onClick={() => navigate("/dashboard")}>
								Book Session
							</Button>
						) : (
							<Button size="large" onClick={() => navigate("/pricing")}>
								View Packages
							</Button>
						)}
						<Button
							size="large"
							variant="outlined"
							onClick={() => navigate("/contact")}
						>
							Contact Us
						</Button>
					</ButtonGroup>
				</HeroContent>

				<ImageWrapper
					initial={{ opacity: 0, scale: 0.8 }}
					animate={{ opacity: 1, scale: 1 }}
					transition={{ duration: 0.8 }}
				>
					<img
						src="/images/hero-baby.jpg"
						alt="Baby Photoshoot"
						onError={(e) => {
							e.target.src = "https://placehold.co/600x400/pink/white?text=ᵔᴥᵔ";
						}}
					/>
				</ImageWrapper>
			</HeroContainer>
		</HeroWrapper>
	);
};

export default Hero;
